import { Line } from "@ant-design/plots";
import { Card } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../loader/loader";

const COLORS = { Sales: "#0891b2", Profit: "#16a34a" };

const SalesProfitTrend = () => {
  const data = useSelector((state) => state.dashboard.list?.saleProfitCount);
  const filteredData = data ? data.filter((d) => d.type === "Sales" || d.type === "Profit") : [];

  const config = {
    data: filteredData,
    xField: "date",
    yField: "amount",
    seriesField: "type",
    height: 260,
    color: (d) => COLORS[d.type] || "#64748b",
    lineStyle: () => ({ lineWidth: 2 }),
    area: true,
    areaStyle: (d) => {
      const color = COLORS[d.type] || "#64748b";
      return { fill: color, fillOpacity: 0.25 };
    },
    yAxis: {
      label: {
        formatter: (v) => `${Number(v) / 1000}K`,
      },
    },
    legend: {
      position: "top-right",
      itemName: { formatter: (v) => v },
    },
    smooth: true,
    animation: { appear: { animation: "path-in", duration: 800 } },
  };

  return (
    <Card
      title="Sales vs Profit Trend"
      size="small"
      className="dashboard-chart-card dashboard-chart-card-compact"
    >
      {filteredData?.length ? <Line {...config} /> : <Loader />}
    </Card>
  );
};

export default SalesProfitTrend;
